import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="relative bg-background-100 py-20 md:py-24 px-4 md:px-8">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
        <div className="reveal flex-1 w-full lg:sticky lg:top-28">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.15] mb-4">
            Got questions?
            <br className="hidden sm:block" /> We&apos;ve got answers
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-sm">
            Here are the answers to the questions we hear most often. Still unsure? Start your trial
            and see it working on your own site in minutes.
          </p>
        </div>

        <div className="flex-1 w-full">
          <div className="divide-y divide-background-300/30 border-t border-background-300/30">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.question} className="py-5">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex items-center justify-between w-full text-left gap-4 cursor-pointer"
                  >
                    <span
                      className={`text-base font-medium transition-colors ${
                        isOpen ? "text-foreground-950" : "text-foreground-800"
                      }`}
                    >
                      {faq.question}
                    </span>
                    <i
                      className={`shrink-0 text-lg transition-transform duration-300 ${
                        isOpen ? "rotate-45 text-accent-400" : "text-foreground-500"
                      } ri-add-line`}
                      aria-hidden
                    ></i>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-in-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="pt-3 text-sm text-foreground-700 leading-relaxed max-w-2xl">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}